import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Catalog from './pages/Catalog';
import SequenceDesign from './pages/SequenceDesign';
import SequencePlayer from './pages/SequencePlayer';
import Navigation from './components/Navigation';
import { SpeechRecognitionProvider } from './context/SpeechRecognitionContext';
import { useSequenceStore } from './store/sequenceStore';

// This component handles store initialization
function StoreInitializer() {
  const { initializeStore } = useSequenceStore();
  
  useEffect(() => {
    console.log('StoreInitializer component mounted');
    // Initialize the store when the app loads
    initializeStore().then(() => {
      console.log('Store initialization completed');
    }).catch(error => {
      console.error('Error during store initialization:', error);
    });
  }, [initializeStore]);
  
  return null;
}

function AppContent() {

  return (
    <div className="min-h-screen bg-gray-50">
      <StoreInitializer />
      <Navigation />
      <main className="container mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<Catalog />} />
          <Route path="/design" element={<SequenceDesign />} />
          <Route path="/player" element={<SequencePlayer />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  // Get the subfolder dynamically
  const base = window.location.pathname.split('/').slice(0, -1).join('/') || '/';
  console.log(`App component rendering from root ${base}`);

  return (
    <Router basename={base}>
      <SpeechRecognitionProvider>
        <AppContent />
      </SpeechRecognitionProvider>
    </Router>
  );
}

export default App;